import { useState } from "react";
import CommentList from "./CommentList/CommentList";
import SeenStateList from "./SeenStateList/SeenStateList";
import { Navbar, NavbarItem } from "../design/navbar";
import ActivityList from "./ActivityList/ActivityList";

interface SideBarViewProps {
  eventId?: string;
  fileId?: string;
  participantId?: string;
  documentId?: string;
  discoveryRequestId?: string;
  taskId?: string;
  subtaskId?: string;
  childSupportOrderId?: string;
  childSupportPaymentId?: string;
  parentingPlanId?: string;
  visitationScheduleId?: string;
  holidayScheduleId?: string;
  custodyOrderId?: string;
}
const SideBarView = (props: SideBarViewProps) => {
  const [state, setState] = useState<"comments" | "seenState" | "activity">(
    "comments",
  );
  return (
    <div className="w-full h-full p-4 overflow-y-auto">
      <Navbar>
        <NavbarItem
          onClick={() => setState("comments")}
          current={state === "comments"}
        >
          Comments
        </NavbarItem>
        <NavbarItem
          onClick={() => setState("seenState")}
          current={state === "seenState"}
        >
          Seen
        </NavbarItem>
        <NavbarItem
          onClick={() => setState("activity")}
          current={state === "activity"}
        >
          Activity
        </NavbarItem>
      </Navbar>
      {state === "comments" && <CommentList {...props} />}
      {state === "seenState" && <SeenStateList {...props} />}
      {state === "activity" && <ActivityList {...props} />}
    </div>
  );
};
export default SideBarView;
